
import Qs from 'qs'
export default {
  getData:{
    method:'get',
    url:'xxx'
  },
}